export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/updateexamschool',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allExamSchools'],
    })
